/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "5474058186faccc687605d86b33d0bdf5b0d985c";
